import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {getUsageReportAsync} from 'src/openapi/admin/apis/UsageReportsV2Api';

import type {ReportType} from 'src/openapi/admin/models/ReportType';
import type {UserUsageCriteria} from 'src/openapi/admin/models/UserUsageCriteria';
import type {ApiDispatchForToolkit} from 'src/openapi/admin/types';

type Props = {
    reportType: ReportType,
    userUsageCriteria: UserUsageCriteria,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useRequestBigReport = ({reportType, onSuccess, onFail, userUsageCriteria}: Props) => {
    const apiDispatch = useDispatch<ApiDispatchForToolkit>();

    const eventAction = useCallback(() => apiDispatch(
        getUsageReportAsync({userUsageCriteria, reportType}),
    ), [apiDispatch, reportType, userUsageCriteria]);

    return useCommonEventHook({
        eventAction,
        onSuccess,
        onFail,
    });
};
